import * as faceapi from "@vladmandic/face-api/dist/face-api.esm.js";
import moment from "moment";
import React from "react";
import Spinner from "../../../../components/SpringLoader/index";
import "./styles.css";

const CapturePhoto = ({
  featuresOnOff,
  setFeaturesOnOff,
  masterClockInOutHandler,
  setConfirmCapturedPhoto,
  timeClockType,
  setFeatures,
  t,
}) => {
  const [isWebcamOn, setIsWebcamOn] = React.useState(false);
  const [isloading, setIsloading] = React.useState(false);
  const [deviceWidth, setDeviceWidth] = React.useState(window.innerWidth);
  const [initializing, setInitializing] = React.useState(false);
  const [capturePhoto, setCapturePhoto] = React.useState(false);
  const [isCameraInitializing, setIsCameraInitializing] = React.useState(true);
  const isMobile = deviceWidth <= 640;
  const videoHeight = 290;
  const videoWidth = 290;
  let videoRef = React.useRef(null);
  let photoRef = React.useRef(null);
  let videoPlayRef = React.useRef(null);
  const [isFeatureReady, setIsFeatureReady] = React.useState(false);
  const camWidth = isMobile ? videoWidth : 389;

  React.useEffect(() => {
    if (isFeatureReady) {
      setTimeout(() => {
        masterClockInOutHandler(timeClockType);
      }, 2000);
    }
  }, [isFeatureReady]);

  React.useEffect(() => {
    featuresOnOff.feature === "capturePhoto" &&
      setTimeout(() => {
        getUserCamera();
      }, 2000);
  }, [featuresOnOff]);

  React.useEffect(() => {
    const loadModels = async () => {
      const MODEL_URL = process.env.PUBLIC_URL + "/models";

      Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
        faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
        faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
        faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
      ]);
    };

    loadModels();

    window.addEventListener("resize", handleWindowSizeChange);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const handleWindowSizeChange = () => {
    setDeviceWidth(window.innerWidth);
  };

  // const getUserCamera = async () => {
  //   await navigator.mediaDevices
  //     .getUserMedia({
  //       video: true,
  //     })
  //     .then((stream) => {
  //       let video = videoRef.current;
  //       video.srcObject = stream;

  //       setIsWebcamOn(true);
  //       video.play().catch((error) => {
  //         console.error(error);
  //       });
  //     });

  //   setIsCameraInitializing(false);
  // };

  const getUserCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        setIsWebcamOn(true);
        await videoRef.current.play();
      }
    } catch (error) {
      console.error("Error accessing webcam:", error);
    } finally {
      setIsCameraInitializing(false);
    }
  };

  const stopUserCamera = () => {
    if (isWebcamOn) {
      clearInterval(videoPlayRef.current);
      if (videoRef.current && videoRef.current.srcObject) {
        let stream = videoRef.current.srcObject;
        let tracks = stream.getTracks();

        tracks.forEach((track) => track.stop()); // Stop all tracks
        videoRef.current.srcObject = null; // Remove video source
      }
      setIsWebcamOn(false);
    }
    setIsloading(false);
  };

  ////for testing without camera
  // const takePic = () => {
  //   setIsloading(true);

  //   // Create a dummy JPEG file (content doesn't matter for testing)
  //   const file = new File(
  //     [new Uint8Array([255, 216, 255, 224])], // minimal JPEG header
  //     `mock-photo-${Date.now()}.jpg`,
  //     { type: "image/jpeg" }
  //   );

  //   submitPhoto(file);
  // };

  // const getUserCamera = async () => {
  //   // DEV ONLY: skip webcam
  //   setIsWebcamOn(true);
  //   setIsCameraInitializing(false);
  //   setCapturePhoto(true);
  // };

  const handleVideoOnPlay = () => {
    let verifyFace2 = setInterval(async () => {
      if (!initializing) {
        photoRef.current.innerHTML = faceapi.createCanvasFromMedia(
          videoRef.current
        );

        if (photoRef.current != null) {
          if (photoRef.current != null && !initializing) {
            photoRef.current
              .getContext("2d")
              .clearRect(0, 0, camWidth, videoHeight);

            setCapturePhoto(true);
          }
        }
      }
    }, 400);

    videoPlayRef.current = verifyFace2;
  };

  const takePic = async () => {
    setIsloading(true);

    let verifyFace = setInterval(async () => {
      photoRef.current.innerHTML = faceapi.createCanvasFromMedia(
        videoRef.current
      );

      if (photoRef.current != null) {
        if (photoRef.current != undefined) {
          photoRef.current
            .getContext("2d")
            .clearRect(0, 0, camWidth, videoHeight);

          let ctx2 = photoRef.current.getContext("2d");
          let img = new Image();
          ctx2.drawImage(videoRef.current, 0, 0, camWidth, videoHeight);
          img.src = photoRef.current.toDataURL("image/jpeg");

          let unixTimestamp = moment().format("X");
          const blob = await (await fetch(img.src)).blob();
          const compressed = new File(
            [blob],
            `profile_img-${unixTimestamp}.jpg`
          );

          clearInterval(verifyFace);
          submitPhoto(compressed);
        }
      }
    }, 200);
  };

  const submitPhoto = async (file) => {
    if (file) {
      setConfirmCapturedPhoto(file);
      setFeaturesOnOff({
        feature: null,
      });
      setFeatures((prev) => {
        return prev.map((item) =>
          item.feature === "capturePhoto" ? { ...item, trail: true } : item
        );
      });
      stopUserCamera();
      setCapturePhoto(false);
      setIsFeatureReady(true);
    }
  };

  // const closeOnCam = async () => {
  //   if (isWebcamOn) {
  //     // clearInterval(faceVerificationInterval);
  //     clearInterval(videoPlayRef.current);
  //     if (videoRef.current && videoRef.current.srcObject) {
  //       let stream = videoRef.current.srcObject;
  //       let tracks = stream.getTracks();

  //       tracks.forEach((track) => {
  //         track.stop(); // Stops each track
  //       });

  //       videoRef.current.srcObject = null;
  //       // await videoRef.current.srcObject.getVideoTracks().forEach((track) => {
  //       //   track.stop();
  //       //   videoRef.current.srcObject.removeTrack(track);
  //       // });
  //     }

  //     setIsWebcamOn(false);
  //   }
  //   setIsloading(false);
  // };

  return (
    <React.Fragment>
      {featuresOnOff.feature === "capturePhoto" && (
        <div className="capturephoto__container">
          <div className="d-flex justify-content-center profile webcamera">
            <video
              id="stream"
              playsInline
              ref={videoRef}
              onPlay={handleVideoOnPlay}
              width="389"
              height={isCameraInitializing ? "100" : "290"}
            ></video>
            <canvas
              id="capture"
              width={camWidth}
              height="290"
              ref={photoRef}
              className="position-absolute"
            ></canvas>
            {isloading || isCameraInitializing ? (
              <Spinner
                containerStyle={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                }}
                addedStyle={{
                  borderTopColor: "#AEABABCC",
                  borderBottomColor: "#AEABABCC",
                }}
              ></Spinner>
            ) : (
              ""
            )}
          </div>

          <div
            className="capturephoto__container-confirm"
            style={{
              marginTop: 30,
            }}
          >
            {isloading ? (
              <p>{t("Capturing photo, please do not move")}</p>
            ) : isWebcamOn && capturePhoto ? (
              <>
                <button
                  type="button"
                  className="btn btn-design btn-brand btn-clockinout"
                  onClick={() => {
                    takePic();
                  }}
                >
                  {t("Take Photo")}
                </button>
              </>
            ) : (
              <>
                <p>{t("Initializing camera, please wait...")}</p>
              </>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default CapturePhoto;
